import request from "./request.js";

export default {
  // 根据idolId获得角色卡
  getCharSetting: (data) => {
    return request({
      url: "api/admin/chat/role/" + data,
      data: data,
      method: "get",
    }).then((res) => {
      return res.data;
    });
  },
  // 根据idolId添加角色卡
  addCharSetting: (data) => {
    return request({
      url: "api/admin/chat/addRole",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  // 更改角色卡
  updateCharSetting: (data) => {
    return request({
      url: "api/admin/chat/updateRole",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  // 设置音频
  setSentenceAudio: (data) => {
    return request({
      url: "api/admin/chat/setSentenceAudio",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
};
